import React from 'react'
import PropTypes from 'prop-types'
import * as S from './styled'

const PageTitle = ({ title, position }) => {
  return <S.Title position={position}>{title}</S.Title>
}

PageTitle.defaultProps = {
  position: '',
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  position: PropTypes.string,
}

export default PageTitle
